<form [formGroup]="formGroup" class="property-details-edit">
    <div class="form-section">
        <h2 class="section-header">GENERAL INFO</h2>
        <div class="row margin-bottom-20" *spIsSpUser="userProfile?.email">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label>PropertyId</label>
            </div>
            <div class="col-md-8 col-sm-12">
                <sp-clipboard-text-box 
                    [value]="property?.propertyId" 
                    hint="Copy to clipboard">
                </sp-clipboard-text-box>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label>Profile Image</label>
            </div>
            <div class="col-md-8 col-sm-12">
                <div>
                    <img *ngIf="property != null && property.profileImage != null" [src]="profileImage" class="profile-image" />
                </div>

                <div class="red margin-bottom-10" *ngIf="errorMessage">
                    <i class="fa fa-exclamation-circle margin-right-5"></i>{{ errorMessage }}
                </div>
                
                <div>                    
                    <label id="btnPhotoBrowse" class="btn btn-action">Select Profile Image</label>
                    <dx-file-uploader                    
                        #dxPhotoFileUpload  
                        dialogTrigger="#btnPhotoBrowse"      
                        [visible]="false"                            
                        [multiple]="false"                                             
                        uploadMode="instantly"                                        
                        (onUploaded)="onDxUploaded()"
                        (onValueChanged)="onDxValueChanged($event)">
                    </dx-file-uploader>
                    
                    <button type="button" class="btn btn-link margin-bottom-20" [hidden]="property.profileImage == null || property.profileImage == ''" (click)="removeProfileImageModal.show()"><i class="fa fa-trash-can margin-right-5"></i> Remove Profile Image</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label>Property Name</label>&nbsp;<span class="red">*</span>
            </div>
            <div class="col-md-8 col-sm-12">
                <input type="text" formControlName="propertyName" class="form-control" required placeholder="Property Name" maxlength="250" />
                <div *ngIf="formGroup.controls['propertyName'].errors && formGroup.controls['propertyName'].pristine" class="error-message">Property Name is required.</div>
                <sp-field-error [controlName]="'Property Name'" [control]="formGroup?.controls?.propertyName"></sp-field-error>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-12 top-buffer-20">
                <label>Property Address </label>&nbsp;<span class="red">*</span>
            </div>
            <div class="col-md-8 col-sm-12">
                <div class="row top-buffer-20">
                    <div class="col-md-12">
                        <input type="text" formControlName="address1" class="form-control" required placeholder="Property Address" maxlength="100" />
                        <div *ngIf="formGroup.controls['address1'].errors && formGroup.controls['address1'].pristine" class="error-message">Property Address is required.</div>
                        <sp-field-error [controlName]="'Property Address'" [control]="formGroup?.controls?.address1"></sp-field-error>
                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-md-12">
                        <input type="text" formControlName="address2" class="form-control" placeholder="Address Line 2" maxlength="100" />
                        <sp-field-error [controlName]="'Address Line 2'" [control]="formGroup?.controls?.address2"></sp-field-error>
                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <input type="text" formControlName="city" class="form-control" required placeholder="City" maxlength="100" />
                        <sp-field-error [controlName]="'City'" [control]="formGroup?.controls?.city"></sp-field-error>
                    </div>

                    <div class="col-md-3 col-sm-3 col-xs-6 clear-padding extendable">
                        <select class="sp-select form-control" formControlName="state">
                            <option *ngFor="let state of states" [value]="state">{{ state }}</option>
                        </select>
                        <sp-field-error [controlName]="'State'" [control]="formGroup?.controls?.state"></sp-field-error>
                    </div>

                    <div class="col-md-3 col-sm-3 col-xs-6 extendable">
                        <input type="text" formControlName="zipCode" class="form-control" required placeholder="Zip Code" minlength="5" maxlength="5" />
                        <div *ngIf="formGroup.controls['zipCode'].errors && formGroup.controls['zipCode'].pristine" class="error-message">zip should consist of 5 numbers.</div>
                        <sp-field-error [controlName]="'Zip Code'" [control]="formGroup?.controls?.zipCode"></sp-field-error>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section">
        <h2 class="section-header">PROPERTY DETAILS</h2>
        <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label for="yearBuilt">Year Built</label>&nbsp;<span class="red">*</span>
            </div>
            <div class="col-md-8 col-sm-12">
                <input type="text" id="yearBuilt" formControlName="yearBuilt" class="form-control" required placeholder="Year Built" maxlength="4" required (keyup)="onYearBuildChanged($event)" />
                <div *ngIf="formGroup.controls['yearBuilt'].errors && formGroup.controls['yearBuilt'].pristine" class="error-message">Year Built is not a valid year.</div>
                <sp-field-error [controlName]="'Year Built'" [control]="formGroup?.controls?.yearBuilt"></sp-field-error>
            </div>
        </div>
        <div class="row top-buffer-20">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label for="propertyType">Property Type</label>
            </div>
            <div class="col-md-8 col-sm-12">
                <select id="propertyType" class="sp-select form-control" formControlName="propertyType">
                    <option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">{{ propertyType.name }}</option>
                </select>
            </div>
        </div>
        <div class="row top-buffer-20">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label for="numberOfUnits">Number of {{ 'Units' | terminology | async }}</label>&nbsp;<span class="red">*</span>
            </div>
            <div class="col-md-8 col-sm-12">
                <input id="numberOfUnits" type="text" formControlName="numberOfUnits" class="form-control" required [placeholder]="(('Units' | terminology | async) || 'Units')" maxlength="5" />
                <div *ngIf="formGroup.controls['numberOfUnits'].errors && formGroup.controls['numberOfUnits'].pristine" class="error-message">Number of {{ 'units' | terminology | async }} should be between 1 and 99999.</div>
                <sp-field-error [controlName]="'Number of Units'" [control]="formGroup?.controls?.numberOfUnits"></sp-field-error>
            </div>
        </div>
        <div class="row top-buffer-20">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label for="numberOfFloors">Number of floors in the building</label>
            </div>
            <div class="col-md-8 col-sm-12">
                <input id="numberOfFloors" type="text" formControlName="numberOfFloors" class="form-control" placeholder="Floors" maxlength="5" />
                <!-- <sp-field-error [controlName]="'Number of Floors'" [control]="formGroup?.controls?.numberOfFloors"></sp-field-error> -->
            </div>
        </div>
        <div class="row top-buffer-20">
            <div class="col-md-12">
                <label id="isCondoConverted" for="isCondoConverted">Was your property ever a condo conversion?</label>
                &nbsp;
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isCondoConverted" (click)="onIsCondoConverted(false)" [value]="false"><span></span> No
                </label>
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isCondoConverted" (click)="onIsCondoConverted(true)" [value]="true"><span></span> Yes
                </label>
            </div>
        </div>
        <div class="row top-buffer-20" [hidden]="!formGroup?.controls?.isCondoConverted.value">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label id="yearOfConversion" for="yearOfConversion">Year Converted</label>&nbsp;<span class="red">*</span>
            </div>
            <div class="col-md-8 col-sm-12">
                <input type="text" formControlName="yearOfConversion" class="form-control" placeholder="Year" minlength="4" maxlength="4" [required]="property?.isCondoConverted" />
                <sp-field-error [controlName]="'Year of Conversion'" [control]="formGroup?.controls?.yearOfConversion"></sp-field-error>
            </div>
        </div>
        <div class="row top-buffer-20">
            <div class="col-lg-2 col-md-3 col-sm-12">
                <label for="propertyDescription">Property Description</label>
            </div>
            <div class="col-md-8 col-sm-12">
                <textarea id="propertyDescription" formControlName="propertyDescription" rows="5" class="form-control" placeholder="Description"></textarea>
                <sp-field-error [controlName]="'Property Description'" [control]="formGroup?.controls?.propertyDescription"></sp-field-error>
            </div>
        </div>
    </div>

    <div class="form-section" *spHasRole="['Admin', 'PortfolioAdmin']">
        <h2 class="section-header">ADVANCED SETTINGS</h2>
        <div class="row top-buffer-20" *spIsSpOrBarreraUser="userProfile?.email">
            <div class="col-md-8 clear-padding-right">
                <label id="isFeatureToggleOn" for="isCondoConverted">Display Projects (Feature Toggle)</label>
            </div>
            <div class="col-md-3">
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isFeatureToggleOn" [value]="false"><span></span> No
                </label>
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isFeatureToggleOn" [value]="true"><span></span> Yes
                </label>
            </div>
        </div>

        <div class="row top-buffer-20" *spIsSpOrBarreraUser="userProfile?.email">
            <div class="col-md-8 clear-padding-right">
                <label id="allowPlanning" for="allowPlanning">Display Planning (current year)</label>
            </div>
            <div class="col-md-3">
                <label class="btn-radio-container">
                    <input type="radio" formControlName="allowPlanning" [value]="false"><span></span> No
                </label>
                <label class="btn-radio-container">
                    <input type="radio" formControlName="allowPlanning" [value]="true"><span></span> Yes
                </label>
            </div>
        </div>

        <div class="row top-buffer-20" *spHasRole="['Admin', 'PortfolioAdmin']">
            <div class="col-md-8 clear-padding-right">
                <label id="isTest" for="isTest">Is this a Test property?</label>
            </div>
            <div class="col-md-3">
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isTest" [value]="false"><span></span> No
                </label>
                <label class="btn-radio-container">
                    <input type="radio" formControlName="isTest" [value]="true"><span></span> Yes
                </label>
            </div>
        </div>
    </div>

    <div class="form-section clear-border" *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']">
        <div class="row align-items-center">
            <div class="col-md-12">
                <button type="button" class="btn btn-default" (click)="onCancel()">Cancel</button>
                <button type="submit" class="btn btn-primary" [disabled]="checkDisabled()" (click)="onSave()">Save Changes</button>
                <span class="red margin-left-10" *ngIf="saveError">
                    <i class="fa fa-exclamation-circle margin-right-5"></i>{{ saveError }}
                </span>
            </div>
        </div>
    </div>
</form>

<sp-modal #removeProfileImageModal title="REMOVE PROFILE IMAGE?" (confirm)="onRemoveProfileImage()" confirmButtonText="Delete Image" isWarning="true">
   <div>Remove profile Image?</div>
</sp-modal>
